import Vue from 'vue'

import Multiselect from "vue-multiselect"

Vue.component("multiselect", Multiselect);